import settings from "@/api/settings";

export default {
    state: {},
    mutations: {},
    actions: {
        async retrieveSettings(context, id) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    id: id,
                }
                const response = await settings.index(params);
                return response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSettingsWater(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    id: "water",
                }
                const response = await settings.index(params);
                return response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async updateSettings(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                await settings.update(params);
            } catch (error) {
                console.log(error);
            }
        },
    },
    getters: {},
};
